import React from "react";
import DashboardAuthoring from "components/pages/dashboard/DashboardAuthoring";
function IndexPage() {
  return (
    <DashboardAuthoring />
  )
}

export default IndexPage;
